'use strict'
const { dataStore } = require("@/observable/store.js")

module.exports.cookie = {
    init: () => getCookieData()
}

let getCookieData =  function (){
    dataStore.isValidUser = true
}